import {IMultiOccurrence, IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IMenuClass} from '../../../../../core/services/menu/menu.service';
import {IRoute} from '../../../../../core/interfaces/route.interface';
import { IFilterExDate } from '../../../../../core/filters/ex-date.filter';
import {IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import {IStateParamsService} from 'angular-ui-router';
import {IMenuItemSelectionClass} from '../../../../../core/services/menu/menu-item-selection.service';

interface IPageMR1012 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    valeursEcran: any; 
}
/* @ngInject */
export default function Mr1012Controller(rr0006Route: IRoute,
                                         Menu: IMenuClass,
                                         exDateFilter: IFilterExDate,
                                         Formulaire: IFormulaireClass,
                                         $stateParams: IStateParamsService,
                                         MenuItemSelection: IMenuItemSelectionClass,
                                         FormulaireItem: IFormulaireItemClass
                                         ) {
    const vm: IPageMR1012= this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            criteresSuggeresVisibles: !$stateParams.employe,
            rechercheCollapsable: false,
            reinitialiserOuvrirCriteres: true,
            effaceCriteres: true
        },
        criteresSuggeres: new Formulaire([
            new FormulaireItem('intcleint'),
            new FormulaireItem('dateinit', {
                required: true,
                default: exDateFilter(new Date())
            }),
            new FormulaireItem('flgaftact'),
        ]),
        navigatePage: rr0006Route.NAME,
            navigateParams: (data: any) => (
                {
                    trncleint: data.trncleint
                }
            ),

        actionsSelection: new Menu([
            new MenuItemSelection(
                'LBL_BTN_TRANS',
                'BOUTRANS', {
                selection: {
                    nom: 'transfert',
                    lblConfirmationTitre: 'LBL_BTN_TRANS',
                    largeurFormulaire: 40,
                    confirmationFormulaire: new Formulaire([
                        new FormulaireItem('intcleinttrans', {
                            largeur: 50,
                            required: true
                        }),
                        new FormulaireItem('datetrans', {
                            largeur: 50,
                            required: true,
                            default: exDateFilter(new Date())
                        }),
                    ])
                },
                fonction: 'BOUTRANS'
            })
        ]),

        colonnesVisibles: [
            {nom: 'eplnummat', largeur: 100, hidden: $stateParams.employe},
            {nom: 'eplnomprn', largeur: 262, hidden: $stateParams.employe},
            {nom: 'aftcod', largeur: 105},
            {nom: 'aftdatdeb', largeur: 110},
            {nom: 'aftdatfin', largeur: 110},
            {nom: 'temcod', largeur: 89},
            {nom: 'ecldsceta', largeur: 126},
            {nom: 'intnomsup', largeur: 220}
        ]
    };
}
